exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".detail-Page .titles-name {\n  font-weight: bold;\n  text-transform: capitalize; }\n\n.detail-Page .values-name {\n  font-weight: bold;\n  text-transform: capitalize; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-2!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js!./src/app/style/detailPage.scss
// module id = 1855
// module chunks = 0